import { Heading } from '@chakra-ui/react'

export function SubTitle({ title }: { title: string }) {
  return (
    <Heading as="h2" fontSize="xl" mb={4}>
      {title}
    </Heading>
  )
}
